import { render, staticRenderFns } from "./organigramModal.vue.html?vue&type=template&id=b2fd1558&scoped=true"
import script from "./organigramModal.controller?vue&type=script&lang=js&external"
export * from "./organigramModal.controller?vue&type=script&lang=js&external"
import style0 from "./organigramModal.vue.html?vue&type=style&index=0&id=b2fd1558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fd1558",
  null
  
)

export default component.exports